// extracted by mini-css-extract-plugin
module.exports = {"container":"bundleLoader_container__2FRBD"};